import { useQuery } from "@tanstack/react-query";
import { getServiceTemplateBy } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Read service template by ID via RCB Service API.
 */ function useServiceTemplateById(id) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getServiceById(id), ({ signal })=>getServiceTemplateBy({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: !!id
    });
}
/**
 * Read service template by ID via RCB Service API.
 */ function useServiceTemplateByIdentifier(identifier) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getServiceByIdentifier(identifier), ({ signal })=>getServiceTemplateBy({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                identifier
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: !!identifier
    });
}
export { useServiceTemplateById, useServiceTemplateByIdentifier };
